import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=2ae94b39&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"
import style0 from "./Reset.vue?vue&type=style&index=0&id=2ae94b39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae94b39",
  null
  
)

export default component.exports